import { writable } from 'svelte/store'
export let mapload = writable(false)
export let maploaded = writable(true)
